import DIApi from './_diApi';
import httpClient from '@/apis/base/httpclient';

class ProjectAPI extends DIApi {
  controllerName = 'Projects';

  /**
   * Tạo một API Post cho trường hợp thêm công trình
   * VDDONG
   */
  saveConstruction(payload) {
    const request = {
      url: this.getAPIUrl() + '/construction',
      data: payload,
    };
    return httpClient.postAsync(request, true);
  }
  //lấy tham số cho b62 nghị định 31
  getParamForB62(year) {
    const request = {
      url: this.getAPIUrl() + `/param-b62?year=${year}`,
    };
    return httpClient.getAsync(request, true);
  }
}

export default new ProjectAPI();
